import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { transactionHistory, withdrawableTransactions, withdrawalHistory } from '../../Services/DashboardServices';

const columns = [
    { name: 'Account Title', selector: row => row.account_title },
    { name: 'Account Number', selector: row => row.account_number.substring(0, 3) + "****" },
    { name: 'Amount', selector: row => row.amount },
    { name: 'Requested At', selector: row => row.request_at },
    { name: 'Released At', selector: row => row.released_at === null || "" ? row.status : row.released_at },
    { name: 'Admin Notes', selector: row => row.admin_notes === null || row.admin_notes === "" ? "--" : row.admin_notes },
    { name: 'Status', selector: row => row.status },
];

const WithdrawableHistory = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleStartDate = (e) => setStartDate(e.target.value);
    const handleEndDate = (e) => setEndDate(e.target.value);

    const handleGetWithdrawableHistory = async () => {
        setLoading(true)
        try {
            const response = await withdrawalHistory(startDate, endDate);
            setData(response?.result?.history?.original?.data || []);
            setLoading(false)
        } catch (err) {
            setLoading(false)
            console.error("Error fetching transaction history", err);
        }
    };

    useEffect(() => { handleGetWithdrawableHistory(); }, [startDate, endDate])


    useEffect(() => {
        const filtered = data.filter(item =>
            Object.values(item).some(value =>
                String(value).toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [filterText, data]);

    return (
        <div>


            <h3 className='fw-bold mb-0'>Withdrawal History</h3>
            <p>
                History of all your's withdrawals request.
            </p>
            <div className='row justify-content-end mb-3'>

                <div className="col-auto">
                    <label className='fw-bold s-12'>Start Date</label>
                    <input value={startDate} onChange={handleStartDate} type="date" className='form-control' />
                </div>
                <div className="col-auto">
                    <label className='fw-bold s-12'>End Date</label>
                    <input value={endDate} onChange={handleEndDate} type="date" className='form-control' />
                </div>
                <div className='col-auto d-flex flex-column justify-content-end'>
                    <label className='fw-bold s-12'>Search</label>
                    <input
                        className='form-control'
                        type="text"
                        placeholder="Search..."
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}

                    />
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div className="spinner-border text-info" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    striped
                />
            )}
        </div>
    );
};

export default WithdrawableHistory;
